import React from "react"
import { Button, Modal } from "react-bootstrap"

import PendingFieldPermissionChangeSummary from "@/onboarding/features/bidding/components/PendingFieldPermissionChangeSummary"
import {
  PendingFieldPermissionChange,
  TourFieldPermissions,
} from "@/onboarding/features/bidding/types"

type Props = {
  show: boolean
  onHide: () => void
  changes: PendingFieldPermissionChange[]
  tours: TourFieldPermissions[]
}

const PendingFieldPermissionChangesModal = ({
  show,
  onHide,
  changes,
  tours,
}: Props): JSX.Element => (
  <Modal
    show={show}
    onHide={onHide}
    size="lg"
    centered
    aria-labelledby="pending-field-permission-changes-modal-title"
  >
    <Modal.Header closeButton>
      <Modal.Title id="pending-field-permission-changes-modal-title">Review changes</Modal.Title>
    </Modal.Header>
    <Modal.Body className="d-flex flex-column gap-4">
      {changes.map((change) => (
        <PendingFieldPermissionChangeSummary
          key={`${change.fieldName}-${change.permissionFlag}`}
          change={change}
          tours={tours}
        />
      ))}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onHide}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
)

export default PendingFieldPermissionChangesModal
